import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'




document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
      <div>
        <App />
      </div>,
    document.body.appendChild(document.createElement('div')),
  )
})



// WEBPACK FOOTER //
// ./src/index.js